/**
 * 在应用启动时初始化 TUIChatKit，确保 TUITranslateService 等服务可用
 * 必须在 TUIKit 组件挂载前执行
 */
import Server from '@/TUIKit/server';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine-lite';

const TUIChatKit = new Server();
TUIChatKit.init();

// 强制使用中文
if (TUITranslateService && typeof TUITranslateService.changeLanguage === 'function') {
  TUITranslateService.changeLanguage('zh');
}

export { TUIChatKit };
